// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".steps>.step[data-v-71922dc8]{min-width:2.5rem}@media (min-width:768px){.steps>.step[data-v-71922dc8]{min-width:12%;min-width:calc(60%/var(--steps, 5))}}@media (min-width:1024px){.steps>.step[data-v-71922dc8]{min-width:20%;min-width:calc(100%/var(--steps, 5))}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
